import type { QuickbooksStatusResponse } from '@contracts/quickbooks/QuickbooksIntegrationContract';
import { QuickbooksSettingsClient } from '@src/quickbooks/services/QuickbooksSettingsClient';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const useQuickbooksDisconnect = () => {
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation<QuickbooksStatusResponse>({
    mutationFn: QuickbooksSettingsClient.disconnect,
    onSuccess: (data) => queryClient.setQueryData(['quickbooksStatus'], data),
  });

  return { disconnect: mutate, loading: isPending };
};
